import { Divider, Box, Flex, Icon, Text } from '@chakra-ui/react';
import React, { useState } from 'react';
import { FaArrowAltCircleUp, FaArrowAltCircleDown } from 'react-icons/fa';

import TablePagination from 'components/Table/TablePagination';

interface ITransactionHistoriesProps {
  histories: any[];
}

const itemsPerPage = 10;

const TransactionHistories: React.FC<ITransactionHistoriesProps> = ({ histories }) => {
  const [currentPage, setCurrentPage] = useState(0);

  // Calculate current items
  const offset = currentPage * itemsPerPage;
  const currentItems = histories.slice(offset, offset + itemsPerPage);
  const pageCount = Math.ceil(histories.length / itemsPerPage);

  // Handle page click
  const handlePageClick = (pageNumber: any) => {
    setCurrentPage(pageNumber);
  };

  return (
    <div>
      {Array.isArray(currentItems) && currentItems.length ? (
        <>
          <Divider my="5" borderBottomWidth="2px" borderStyle="dashed" />
          <Box pb="8">
            <Text fontSize="md" fontWeight="semibold" mb="3">
              Transaction History
            </Text>
            {currentItems.map((item: any, index: number) => (
              <Box key={index} py="2" px="3" mb="3" borderRadius="lg" boxShadow="1px 1px 4px 2px rgba(0,0,0,0.1)">
                <Flex justifyContent="space-between" mb="1">
                  <Text fontWeight="semibold">{item?.entered_by}</Text>
                  <Text>{item?.date} </Text>
                </Flex>
                <Flex justifyContent="space-between">
                  <Text color="gray.600">{item?.description}</Text>

                  <Text
                    flex="0 0 150px"
                    textAlign="right"
                    fontWeight="semibold"
                    color={item?.is_credit ? 'success.500' : 'newRed.1000'}
                  >
                    {item?.hours} <Icon as={item?.is_credit ? FaArrowAltCircleUp : FaArrowAltCircleDown} mb="3px" />
                  </Text>
                </Flex>
              </Box>
            ))}
            <TablePagination
              currentPage={currentPage}
              pageCount={pageCount}
              onPageChange={handlePageClick}
              pageRangeDisplayed={2}
            />
          </Box>
        </>
      ) : null}
    </div>
  );
};

export default TransactionHistories;
